import React from "react";
import { Card, CardHeader, CardBody, Row, Col, Button } from "reactstrap";
import { func } from "prop-types";

function BackupOrSkip({ onBackup, onSkip, secretKey }) {
  return (
    <Card>
      <CardHeader>Backup secret key:</CardHeader>
      <CardBody>
        <Row>
          <Col className="mb-4">Do you want to backup secret key now?</Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Button
            color="warning"
            type="button"
            className="mr-4"
            onClick={onSkip}
            data-cy="skip">
            Skip
          </Button>
          <Button
            color="success"
            type="button"
            onClick={onBackup}
            data-cy="backup">
            Backup
          </Button>
        </Row>
      </CardBody>
    </Card>
  );
}

BackupOrSkip.propTypes = {
  onBackup: func.isRequired,
  onSkip: func.isRequired,
};

BackupOrSkip.defaultProps = {
  onBackup: () => {},
  onSkip: () => {},
};

export default BackupOrSkip;
